<template>
  <div class="page_footer">
    <div class="footer_content">
      <div class="footer_title clearfix">
        <div class="left">关于协会</div>
        <div class="left">新闻动态</div>
        <div class="left">人物纵横</div>
        <div class="left">赛事通道</div>
        <div class="left">媒体中心</div>
      </div>
      <div class="footer_item clearfix">
        <div class="left">
          <ul>
            <li>协会介绍</li>
            <li>通知公告</li>
          </ul>
        </div>
        <div class="left">
          <ul>
            <li>羽协新闻</li>
            <li>赛事新闻</li>
            <li>精彩专题</li>
          </ul>
        </div>
        <div class="left">
          <ul>
            <li>羽坛明星</li>
            <li>教练介绍</li>
            <li>世界排名</li>
            <li>羽球裁判</li>
          </ul>
        </div>
        <div class="left">
          <ul>
            <li>申请中心</li>
            <li>报名入口</li>
          </ul>
        </div>
        <div class="left">
          <ul>
            <li>媒体申请</li>
            <li>视频</li>
            <li>图片</li>
          </ul>
        </div>
      </div>
      <div class="footer_msg clearfix">
        <div class="left">
          本网站由上海市羽毛球协会官方唯一技术合作伙伴智羽提供支持<br>
          沪ICP备17012145号
        </div>
        <div class="right">
          联系我们 &nbsp;&nbsp;&nbsp;&nbsp;
          法律声明 &nbsp;&nbsp;&nbsp;&nbsp;
          网站地图
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-header'
}
</script>



// WEBPACK FOOTER //
// src/containers/page-footer.vue